import React, { Component } from 'react';
import { Grid, Header, Icon, Popup, Responsive, Segment, Tab } from 'semantic-ui-react';
import { IconHeader } from '../../util/css';
import Info from './Info';
import Rooms from './Rooms';
import Resources from './Resources';

class Details extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        };
    }

    render() {
        const orgUnitProperty = JSON.parse(localStorage.getItem('orgUnitProperty'));
        const panes = [
            {
                menuItem: 'Osnovni podaci',
                render: () => (
                    <Tab.Pane attached={false} as={Responsive} >
                        <Info orgUnitProperty={orgUnitProperty} />
                    </Tab.Pane>),
            },
            {
                menuItem: 'Prostorije',
                render: () =>
                    (<Tab.Pane attached={false} as={Responsive}>
                        <Rooms orgUnitProperty={orgUnitProperty} />
                    </Tab.Pane>),
            },
            {
                menuItem: 'Sredstva',
                render: () =>
                    (<Tab.Pane attached={false} as={Responsive}>
                        <Resources orgUnitProperty={orgUnitProperty} />
                    </Tab.Pane>),
            },

        ];

        return (
            <div>
                <h1> Detalji </h1>
                <Grid columns="equal" centered className="stackable">
                    <Grid.Column>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">
                                    {orgUnitProperty.property.name}
                                    <Header style={IconHeader} floated="right">
                                        <Icon />
                                        <Popup
                                            trigger={<Icon link circular basic floated="right" name="arrow left" onClick={() => window.history.go(-1)} />}
                                            content="Nazad"
                                            hideOnScroll
                                            position="top center"
                                        />
                                    </Header>
                                    <Header.Subheader>
                                        Naziv imovine
                                    </Header.Subheader>

                                </Header>
                            </Segment>
                            <Segment>

                                <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

export default Details;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Details/Details.js